import { i18n } from '@/i18n'
import store from '@/store'
import getNestedValue from '@/services/functions/getNestedValue'

const defaultEnumId = ['id', 'key']
const defaultEnumValue = ['value', 'name', 'Nombre']
 
function searchValue (item, keys = [], falsys = [undefined]) {
  if (item !== null && item !== undefined) {
    if (!keys.length) {
      return item
    }
    for (const key of keys) {
      if (!falsys.includes(key)) {
        const value = getNestedValue(key, item)
        if (!falsys.includes(value)) {
          return value
        }
      }
    }
  }
  return undefined
}

function isJSONArray (value) {
  try {
    return Array.isArray(JSON.parse(value))
  } catch {
    return false
  }
}

function getEnumTranslatedValue (value, formatKey, field, { idEnumField = undefined, valueEnumField = undefined, ignoreNull = true } = {}) {
  if (formatKey?.length && (!ignoreNull || ![null, undefined].includes(value))) {
    const finalFormats = (isJSONArray(formatKey) ? JSON.parse(formatKey) : [formatKey]).reduce((acc, format) => ({ ...acc, [format]: store.getters[`config/${format}`] }), {})
    const formats = Object.entries(finalFormats)
    const warns = []
    for (const [format, myenum] of formats) {
      if (myenum) {
        const enumItem = myenum.find(x => searchValue(x, [idEnumField, ...defaultEnumId]) === value)
        const enumValue = searchValue(enumItem, [valueEnumField, ...defaultEnumValue])
        if (enumValue) {
          return enumValue
        } else {
          const strValue = typeof value?.trim === 'function' && value.trim() === '' ? `"${value}"` : value
          warns.push(i18n.t('feedback.warning.bad_conf_enum_value_warn', { field, config: format, value: strValue })) 
        }
      } else {
        console.error(i18n.t('feedback.error.bad_enum_config_error', { field, config: format }))
      }
    }
    warns.forEach(w => console.warn(w))
  }
  return value
}

export default getEnumTranslatedValue
